import AdminApplications from "../../components/Admin/AdminApplications";
import DashboardLayout from "../../components/Layout/DashboardLayout";
import { applicationStatusMap } from "../../config/applicationStatusConfig";

const DLCTVerifiedApplications = () => {
  return (
    <DashboardLayout pageTitle="Application" mainClass="p-6">
      <AdminApplications
        title="Verified Applications(DLCT)"
        status={[applicationStatusMap?.dlctVerified.value]}
        stage={[]}
      />
    </DashboardLayout>
  );
};

export default DLCTVerifiedApplications;
